var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 8.66659L15.3093 11.3746L13.3273 11.9413L14.744 14.3953L13.5893 15.0619L12.1727 12.6086L10.6907 14.0419L10.6667 8.66659ZM9.33333 3.99992H10.6667V5.33325H14C14.1768 5.33325 14.3464 5.40349 14.4714 5.52851C14.5964 5.65354 14.6667 5.82311 14.6667 5.99992V8.66659H13.3333V6.66659H6.66666V13.3333H9.33333V14.6666H6C5.82318 14.6666 5.65361 14.5963 5.52859 14.4713C5.40357 14.3463 5.33333 14.1767 5.33333 13.9999V10.6666H3.99999V9.33325H5.33333V5.99992C5.33333 5.82311 5.40357 5.65354 5.52859 5.52851C5.65361 5.40349 5.82318 5.33325 6 5.33325H9.33333V3.99992ZM2.66666 9.33325V10.6666H1.33333V9.33325H2.66666ZM2.66666 6.66659V7.99992H1.33333V6.66659H2.66666ZM2.66666 3.99992V5.33325H1.33333V3.99992H2.66666ZM2.66666 1.33325V2.66659H1.33333V1.33325H2.66666ZM5.33333 1.33325V2.66659H3.99999V1.33325H5.33333ZM8 1.33325V2.66659H6.66666V1.33325H8ZM10.6667 1.33325V2.66659H9.33333V1.33325H10.6667Z",
    fill: "#505762"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.b9cc88bdd6e089bc983b0ed67e7a0f31.svg";
export { ForwardRef as ReactComponent };